<template>
  <component
    :is="button ? 'button' : 'a'"
    :type="button ? 'button' : null"
    :class="['btn position-relative d-flex flex-row align-items-center gap-2', ghost ? 'btn-ghost' : 'btn-flat', `text-${align}`, {active}, {'btn-sm':small}, {'no-padding':noPadding}, {'btn-compact':compact}]"
    :title="title"
    :data-bs-title="title"
    v-bind="$attrs">
    <i :class="`bi-${icon} ${variant ? `text-${variant}` : ''}`"/>
    <span v-if="text" :class="variant ? `text-${variant}` : ''">{{ text }}</span>
    <b-overlay v-if="busy">
      <spinner-view small />
    </b-overlay>
  </component>
</template>

<script>
import BOverlay from "@/components/common/BOverlay.vue";
import SpinnerView from "@/components/common/SpinnerView.vue";

export default {
  components: {SpinnerView, BOverlay},
  props: {
    icon: String,
    // Note: Providing a title will cause the tooltip plugin to be used, which breaks the dropdown feature. Do not use
    // both simultaneously.
    title: String,
    text: String,
    active: Boolean,
    button: Boolean,
    small: Boolean,
    variant: String,
    busy: Boolean,
    noPadding: Boolean,
    ghost: Boolean,
    compact: Boolean,
    align: {
      type: String,
      default: 'center'
    }
  },
  data() {
    return {
      tooltip: null
    };
  },
  watch: {
    title() {
      this.$nextTick(() => {
        this.updateTooltip();
      });
    }
  },
  mounted() {
    this.updateTooltip();
  },
  beforeUnmount() {
    this.updateTooltip(true);
  },
  methods: {
    updateTooltip(skipCreation) {
      if (this.tooltip) {
        try {
          this.tooltip.dispose();
        } catch (error) {
          console.warn('Could not dispose tooltip', error);
        }
      }
      if (!skipCreation && this.title) {
        this.tooltip = new this.bootstrap.Tooltip(this.$el);
      }
    }
  }
}
</script>

<style>
.btn.no-padding {
  padding: 0 !important;
}
.btn-flat.no-padding:hover {
  background-color: transparent;
}
</style>
